export const isMiniProgram = (ua: string = "") => {
  const key = 'miniprogram';
  const _ua = ua.toLocaleLowerCase();
  return _ua.includes(key);
}

export const isMiniProgramIOS = (ua: string = "") => {
  const key = 'miniprogram';
  const iosKey = 'iphone'
  const _ua = ua.toLocaleLowerCase();
  return _ua.includes(key) && _ua.includes(iosKey);
}